import { ErrorHandler, inject } from '@angular/core';
import { ExceptionImpl } from '@ipensii/error/domain-error';
import { AuthService, CacheService } from '@ipensii/shared/data-access-shared';
import { PICKER_REQUEST_ID_STORAGE_KEY } from '@ipensii/shared/domain-shared';
import { ExceptionService } from './exception.service';

export class ClientErrorInterceptor implements ErrorHandler {
  private readonly authService = inject(AuthService);
  private readonly cacheService = inject(CacheService);
  private readonly exceptionService = inject(ExceptionService);

  handleError(error: Error): void {
    if (this.authService.isLoggedIn) {
      const user = this.authService.authUser;
      const requestId = this.cacheService.getItem(PICKER_REQUEST_ID_STORAGE_KEY);
      const resource = ExceptionImpl.fromError(error, user || requestId);
      this.exceptionService.save({ resource }).subscribe();
    }
    console.error(error);
  }
}
